module.exports = (__webpack_require__(0))(247);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/App.js from dll-reference girder_lib
// module id = 158
// module chunks = 0